import { render, staticRenderFns } from "./ting_management.vue?vue&type=template&id=5861ab6f&"
import script from "./ting_management.vue?vue&type=script&lang=js&"
export * from "./ting_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports